import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link, useParams } from 'react-router-dom';
import { Dropdown, Button } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { checkArray, treadFile, imageUrl } from '../../../Components/helper';
import BtnAddToCareGroup from './BtnAddToCareGroup';
import * as action from './store/CareLabel.action';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { useCareLabelState } from './context/index';
import ImportModal from '../BomLibrary/ImportModal';
import ConfirmationModalForUpload from '../BomLibrary/ConfirmationModalForUpload';
import ErrorModal from '../BomLibrary/ErrorModal';

function LibraryFilter({
  selectedLibrary,
  handleAddLibrary,
  handleDeleteMultiple,
  handleCheckAll,
  isallChecked,
  handleLibrarySearchText,
  handleSearchSubmit,
  searchText,
  CareAddEditAccess,
  CareDeleteAccess,
  setCareLabelState,
}) {
  const dispatch = useDispatch();
  const { careType } = useParams();
  const docRef = useRef(null);
  const history = useHistory();
  const {
    CareLabelReducer: { careGroupFilterOption },
    UserDetails: { userInfo },
  } = useSelector((reduxState) => reduxState);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadSelectLoading, setDownloadSelectLoading] = useState(false);
  const { careLabelState, getCurrentLibraryData } = useCareLabelState();
  const { t } = useTranslation('common');
  const [showModal, setShowModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [checked, setChecked] = useState(false);
  const [files, setFiles] = useState(false);
  const [showErr, setShowErr] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [successCount, setSuccessCount] = useState(0);
  const [fileName, setFileName] = useState('');

  const { CareLabelList } = careLabelState;
  useEffect(() => {
    const getCareGroup = async () => {
      await dispatch(action.fetchCareLabelGroupByUserId(userInfo?.userId));
    };
    getCareGroup();
  }, []);

  const uploadXlsx = async () => {
    setShowModal(true);
  };

  const closeUploadModal = () => {
    setShowModal(false);
  };

  const hasDuplicateTestingCode = (data) => {
    if (CareLabelList?.length > 0) {
      const testData = [];
      const array = CareLabelList?.find((element) => data.some((obj) => obj['Code*'] === element.code || obj['Code *'] === element.code));
      // eslint-disable-next-line no-unused-expressions
      array && testData.push(array);
      return testData;
    }
    return [];
  };
  const togglePreview = async () => {
    setConfirmModal(false);
  };
  const handleNoButtonClick = async () => {
    setConfirmModal(false);
    setChecked(false);
  };

  const handleYesButtonClick = async () => {
    setConfirmModal(false);
    setChecked(true);
    const params = {
      xls: files,
      checked,
      careType,
    };
    const res = await dispatch(action.importCareLib(params, t));
    if (res.code === 200) {
      setChecked(false);
      setCareLabelState((prevState) => ({
        ...prevState,
        CareLabelList: [],
        selectedLibrary: [],
        pageIndex: 1,
        hasMore: false,
        totalCount: 0,
      }));
      await getCurrentLibraryData();

      if (res?.data?.logErr?.length > 0) {
        setShowErr(true);
        setTotalCount(res?.data?.totalCount);
        setErrorCount(res?.data?.errorDataCount);
        setSuccessCount(res?.data?.successDataCount);
      }
      if (res?.data?.file) {
        setFileName(res?.data?.file);
      }
    }
  };

  const handleErrorDownload = () => {
    const fileUrl = fileName.startsWith('http') ? fileName : `${imageUrl}${fileName}`;
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const toggleErr = () => {
    setShowErr(false);
  };

  const handleFile = async () => {
    if (docRef?.current) {
      const uploadedDoc = await docRef.current.selectedDocument();
      if (uploadedDoc) {
        const binary = uploadedDoc.document;
        binary.fileName = binary.name;
        setFiles(binary);
        if (binary.size > 5000000) {
          toasterMsg(t('CARE_LABEL.FILE_ERROR'), 'danger');
        } else {
          const convertedXlsxToArray = await treadFile(binary, true);
          const params = {
            xls: binary,
            checked,
            careType,
          };

          const checkDuplicateTestingCode = hasDuplicateTestingCode(convertedXlsxToArray.data);
          if (checkDuplicateTestingCode && checkDuplicateTestingCode.length > 0) {
            setConfirmModal(true);
            closeUploadModal();
          } else {
            const res = await dispatch(action.importCareLib(params, t));
            if (res?.code === 200) {
              setChecked(false);
              setCareLabelState((prevState) => ({
                ...prevState,
                CareLabelList: [],
                selectedLibrary: [],
                pageIndex: 1,
                hasMore: false,
                totalCount: 0,
              }));
              await getCurrentLibraryData();

              if (res?.data?.logErr?.length > 0) {
                setShowErr(true);
                setTotalCount(res?.data?.totalCount);
                setErrorCount(res?.data?.errorDataCount);
                setSuccessCount(res?.data?.successDataCount);
              }
              if (res?.data?.file) {
                setFileName(res?.data?.file);
              }
            }
            closeUploadModal();
          }
        }
      } else {
        toasterMsg(t('CARE_LABELS.LIBRARY_FILTER.FILE_EXTENSION'), 'danger');
      }
    }
  };
  const onBtnClick = (selectedId) => {
    if (selectedLibrary.length > 0) {
      if (selectedId?._id) {
        history.push(`/libraries/care-group/edit/${selectedId._id}`, selectedLibrary);
      }
    } else {
      toasterMsg(t('CARE_LABELS.LIBRARY_FILTER.CARE_LABEL_GROUP'), 'danger');
    }
  };
  const handleOpenProductGroup = () => {
    if (selectedLibrary.length > 0) {
      history.push('/libraries/care-group/add', selectedLibrary);
    } else {
      toasterMsg(t('CARE_LABELS.LIBRARY_FILTER.CARE_LABEL_ADD_GROUP'), 'danger');
    }
  };
  const handleDownload = async (type) => {
    if (type === 'All') {
      setDownloadLoading(true);
      const data = {
        careType,
      };
      await dispatch(action.downloadCareLibrary(data));
      setDownloadLoading(false);
    } else if (type === 'Sample') {
      const data = {
        type: 'sample',
        careType,
      };
      await dispatch(action.downloadCareLibrary(data));
    } else if (type === 'selected') {
      setDownloadSelectLoading(true);
      const data = {
        careIds: selectedLibrary,
        careType,
      };
      await dispatch(action.downloadCareLibrary(data));
      setDownloadSelectLoading(false);
    }
  };

  return (
    <div className="search-filter care-library-filter">
      <div className="product-list-search w-300">
        <div className="form w-100">
          <input
            type="text"
            value={searchText}
            onChange={(e) => handleLibrarySearchText(e.target.value)}
            onKeyDown={handleSearchSubmit}
            className="form-control"
            placeholder={t('CARE_LABELS.LIBRARY_FILTER.CARE_LIBRARY')}
          />
        </div>
      </div>
      <Dropdown className="supplier-more-option">
        <Dropdown.Toggle>
          <button aria-label={t('CARE_LABELS.LIBRARY_FILTER.DOWNLOAD')} className="filter-btn" type="button">
            <i title={t('CARE_LABELS.LIBRARY_FILTER.DOWNLOAD')} className="icon-download" />
          </button>
        </Dropdown.Toggle>
        <Dropdown.Menu align="end">
          <>
            <Link className="dropdown-item" to={() => false} onClick={() => handleDownload('Sample')}>
              {t('COLOUR_LIBRARY.DOWNLOAD_SAMPLE_FILE')}
            </Link>

            <Button className="dropdown-item" disabled={isEmpty(selectedLibrary)} onClick={() => handleDownload('selected')}>
              {downloadSelectLoading ? 'Downloading...' : `${t('COLOUR_LIBRARY.DOWNLOAD_SELECTED_DATA')}`}
            </Button>

            <Button
              disabled={!CareLabelList?.length}
              className={downloadLoading ? 'dropdown-item disabled-btn' : 'dropdown-item'}
              onClick={() => handleDownload('All')}
            >
              {downloadLoading ? 'Downloading...' : `${t('COLOUR_LIBRARY.DOWNLOAD_ALL_DATA')}`}
            </Button>
          </>
        </Dropdown.Menu>
      </Dropdown>

      {CareAddEditAccess && (
        <button
          type="button"
          title={t('CARE_LABEL.UPLOAD_EXCEL_DOCUMENT')}
          onClick={() => uploadXlsx()}
          className="filter-btn"
          aria-label={t('CARE_LABEL.UPLOAD_EXCEL_DOCUMENT')}
        >
          <i className="icon-upload" />
        </button>
      )}

      {CareAddEditAccess && (
        <button type="button" onClick={() => handleAddLibrary()} className="filter-btn filter-button_add">
          <i className="icon-add" />
        </button>
      )}

      <BtnAddToCareGroup
        onBtnClick={onBtnClick}
        options={careGroupFilterOption}
        CareAddEditAccess={CareAddEditAccess}
        handleOpenProductGroup={handleOpenProductGroup}
      />

      {CareDeleteAccess && (
        <button
          type="button"
          title={t('CARE_LABELS.LIBRARY_FILTER.DELETE_LIBRARY')}
          onClick={() => handleDeleteMultiple()}
          className="filter-btn filter-button_add"
          disabled={!checkArray(selectedLibrary)}
        >
          <i className="icon-delete" />
        </button>
      )}

      {showModal && <ImportModal showUploadModal={showModal} closeUploadModal={closeUploadModal} docRef={docRef} addDocument={handleFile} loader={false} />}
      {confirmModal && (
        <ConfirmationModalForUpload
          onOpen={confirmModal}
          toggle={togglePreview}
          title={t('CARE_LABEL.UPLOAD_EXCEL')}
          description={t('CARE_LABEL.UPLOAD_DISCRIPTION')}
          checked={checked}
          handleNoButtonClick={handleNoButtonClick}
          handleYesButtonClick={handleYesButtonClick}
        />
      )}
      {showErr && (
        <ErrorModal
          totalCount={totalCount}
          successCount={successCount}
          errorCount={errorCount}
          title={t('CARE_LABEL.UPLOAD_EXCEL')}
          onOpen={showErr}
          toggle={toggleErr}
          handleErrorDownload={handleErrorDownload}
        />
      )}

      <div className="break" />
      <div className="selectall-checkbox">
        <input type="checkbox" name="selectAll" id="selectAll" onChange={(e) => handleCheckAll(e)} checked={isallChecked} />
        <label htmlFor="selectAll" className="btn btn-white btn-back-lib mb-0">
          <span>
            {isallChecked ? 'Unselect' : 'Select'}
            {t('CARE_LABELS.LIBRARY_FILTER.ALL')}
          </span>
        </label>
      </div>
    </div>
  );
}

export default LibraryFilter;
